import { LayoutGrid, List } from 'lucide-react';
import { memo } from 'react';

import {
  GAP_SCALE,
  PADDING_X,
  PADDING_Y,
  SIZE_SCALE,
  FLEX,
  FLEX_ALIGN,
  COLOR_SCALE,
  RADIUS_SCALE,
  BORDER_WIDTH,
  SHADOW_SCALE,
  SURFACE_PADDING,
  INTERACTIVE_STATES,
  DURATION_SCALE,
} from '@/components/design-system/tokens';
import { Button } from '@/components/ui';

interface ViewModeToggleProps {
  value: 'list' | 'grid';
  onChange: (value: 'list' | 'grid') => void;
}

function ViewModeToggle({ value, onChange }: ViewModeToggleProps) {
  const isActive = (mode: 'list' | 'grid') => value === mode;

  return (
    <div
      className={`${FLEX.flex} ${FLEX_ALIGN.center} ${GAP_SCALE['0.5']} ${COLOR_SCALE['slate-50']} ${RADIUS_SCALE.lg} ${BORDER_WIDTH.thin} ${COLOR_SCALE['slate-200']} ${SURFACE_PADDING['0.5']} ${SHADOW_SCALE.sm}`}
    >
      <Button
        onClick={() => onChange('list')}
        variant="ghost"
        size="sm"
        className={`${PADDING_X['3']} ${PADDING_Y['2']} ${RADIUS_SCALE.md} ${INTERACTIVE_STATES.transitions.all} ${DURATION_SCALE.normal} ${
          isActive('list')
            ? `${COLOR_SCALE.surface} ${COLOR_SCALE['blue-600']} ${SHADOW_SCALE.sm} hover:${COLOR_SCALE.surface}`
            : `${COLOR_SCALE['slate-500']} hover:${COLOR_SCALE['gray-700']} hover:bg-slate-25/50`
        }`}
      >
        <List className={`${SIZE_SCALE.w4} ${SIZE_SCALE['4']}`} />
      </Button>
      <Button
        onClick={() => onChange('grid')}
        variant="ghost"
        size="sm"
        className={`${PADDING_X['3']} ${PADDING_Y['2']} ${RADIUS_SCALE.md} ${INTERACTIVE_STATES.transitions.all} ${DURATION_SCALE.normal} ${
          isActive('grid')
            ? `${COLOR_SCALE.surface} ${COLOR_SCALE['blue-600']} ${SHADOW_SCALE.sm} hover:${COLOR_SCALE.surface}`
            : `${COLOR_SCALE['slate-500']} hover:${COLOR_SCALE['gray-700']} hover:bg-slate-25/50`
        }`}
      >
        <LayoutGrid className={`${SIZE_SCALE.w4} ${SIZE_SCALE['4']}`} />
      </Button>
    </div>
  );
}

export default memo(ViewModeToggle);
